/**
 * Surcharge globale de Date pour simuler une date système.
 *
 * - new Date()          → date simulée (le temps avance normalement)
 * - Date.now()          → timestamp simulé
 * - new Date('2020-01-01') → fonctionne normalement
 *
 * Usage serveur :
 *   import { installFakeDate } from '@shared/clock.js'
 *   installFakeDate(process.env.DEBUG_DATE)
 *
 * Usage frontend :
 *   import { installFakeDate } from '@shared/clock.js'
 *   installFakeDate(__DEBUG_DATE__)   // injecté par Vite define
 */

const _OriginalDate = globalThis.Date

export function installFakeDate(debugDateStr) {
  if (!debugDateStr) return false

  const fakeNow = new _OriginalDate(debugDateStr)
  if (isNaN(fakeNow.getTime())) {
    console.warn(`[clock] DEBUG_DATE invalide: "${debugDateStr}" — date systeme utilisee`)
    return false
  }

  const offset = fakeNow.getTime() - _OriginalDate.now()

  function FakeDate(...args) {
    if (!new.target) {
      return new _OriginalDate(_OriginalDate.now() + offset).toString()
    }
    if (args.length === 0) {
      return new _OriginalDate(_OriginalDate.now() + offset)
    }
    return new _OriginalDate(...args)
  }

  FakeDate.prototype = _OriginalDate.prototype
  FakeDate.now = () => _OriginalDate.now() + offset
  FakeDate.parse = _OriginalDate.parse.bind(_OriginalDate)
  FakeDate.UTC = _OriginalDate.UTC.bind(_OriginalDate)

  Object.defineProperty(FakeDate, Symbol.hasInstance, {
    value: (instance) => instance instanceof _OriginalDate
  })

  globalThis.Date = FakeDate

  const days = Math.round(offset / 86400000)
  console.log(`[clock] DEBUG_DATE actif: ${fakeNow.toISOString()} (offset ${days >= 0 ? '+' : ''}${days}j)`)
  return true
}

export function resetClock() {
  globalThis.Date = _OriginalDate
  console.log('[clock] DEBUG_DATE desactive — retour a la date systeme')
}

export { _OriginalDate }
